module.exports = __webpack_public_path__ + "media/images/smart_phone/shares/202001/e_logo-0115fc7e36dcded26c66c308348b5faf.png";